import { createActions } from 'redux-actions'

export const { issueNotification, dismissNotification } = createActions({
  ISSUE_NOTIFICATION: (children, contextualClass) => ({children, contextualClass}),
  DISMISS_NOTIFICATION: (id) => ({id}),
})
